//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import validateAccountMixin from '@motionelements/core/src/components/mixins/validate-account.mixin.js';

export default {
  name: 'SubscribeBtn',
  mixins: [validateAccountMixin],
  props: {
    buttonClass: String,
    planSku: String,
  },
  computed: {
    ...mapState({
      subscriptions: state => state.user.member.subscriptions,
    }),
    ...mapGetters({
      isResellerCustomer: 'user/isResellerCustomer',
      isPlansLoaded: 'subscription/isPlansLoaded',
      getPlanBilledYearly: 'subscription/getPlanBilledYearly',
    }),
    isCtaDisabled() {
      return this.hasSimilarSubscription || this.isLoggedInButUnactivated;
    },
    hasSimilarSubscription() {
      return _.get(this.getPlanBilledYearly, 'unlimited')
        && this.subscriptions && this.subscriptions.includes('unlimited');
    },
    ctaLabel() {
      if (this.hasSimilarSubscription) {
        return this.$i18n.t('subscription.subscribed');
      }
      return this.$i18n.t('cta.subscribe_now');
    },
  },
  methods: {
    onClickCta() {
      if (this.hasSimilarSubscription) {
        return false;
      }

      if (this.isResellerCustomer) {
        return false;
      }

      if (!this.validateAccount()) {
        return;
      }

      window.location.href = this.$link(`/subscribe/payment?plan=${this.planSku || this.getPlanBilledYearly.sku}`).param('coupon', this.$route.query.coupon).url();
    },
  },
};
